import { UserOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { TomTomMaps } from "../../../components/CustomForm/TomTomMaps/TomTomMaps";

export const addresseItemMapsInputs = ({
  location = "",
  maps,
  changeEdition = null,
}) => {
  const inputs = [
    {
      children: [
        {
          name: "location",
          label: "Lieu de l'intervention (Institution)",
          value: location,
          required: true,
          type: "input",
          col: 24,
        },
        {
          required: true,
          label: "Adresse d'intervention réelle",
          name: "maps",
          value: maps,
          type: "google-adress",
          onChange: a => {
            console.log(a);
          },
          col: 24,
        },
        {
          col: 24,
          type: "component",
          name: "mapstomtom",
          noWrapper: true,
          component: ({ refForm }) => (
            <TomTomMaps keys={"maps"} refForm={refForm} />
          ),
        },
      ],
    },
  ];

  if (changeEdition !== null) {
    inputs[0].children.push({
      label: "Sauvegarder",
      type: "submit",
      size: "small",
    });

    inputs[0].children.push({
      type: "component",
      component: () => (
        <Button
          onClick={changeEdition}
          size={"small"}
          type={"primary"}
          style={{ marginRight: 10 }}
        >
          Annuler
        </Button>
      ),
    });
  }

  return inputs;
};
